export default {
  // set event listener to local rtc before join the channel
  setEventListener() {
    for (let { event, resolve } of this.events) {
      this.rtc.on(event, resolve);
    }
  }
}

